// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__CrHyb","slide-down":"Overlay_slide-down__UC-aa"};